import type { Resource } from '@medplum/fhirtypes';
import React from 'react';

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@eluve/components';

// A syntax-free JSON viewer for FHIR resources — enough for the demo's
// "show me the exact resource" affordance.
export function FhirJsonDialog({
  resource,
  title,
  description,
  trigger,
}: {
  resource: Resource;
  title: string;
  description?: string;
  trigger: React.ReactNode;
}) {
  return (
    <Dialog>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent size="4xl" className="max-h-[80vh] overflow-hidden">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description ? (
            <DialogDescription>{description}</DialogDescription>
          ) : null}
        </DialogHeader>
        <pre className="max-h-[60vh] overflow-auto rounded-lg bg-bg-tertiary p-4 font-mono text-xs text-foreground">
          {JSON.stringify(resource, null, 2)}
        </pre>
      </DialogContent>
    </Dialog>
  );
}
